import { HoursOptionsProps, useHoursOptions } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { SelectField, SelectFieldProps } from '../SelectField';

type HourSelectFieldProps = HoursOptionsProps & Omit<SelectFieldProps, 'options'>;

export const HourSelectField = ({ minValue, maxValue, ...others }: HourSelectFieldProps) => (
    <SelectField label={lt('Hours')} {...others} options={useHoursOptions({ minValue, maxValue })} />
);
